import { FormInput, Newlogo, Text, Button } from "../../components";
import { fontSizes } from "../../constants/constants";
import Functions from "./index.function";
const ForgetPassword = () => {
  const {
    TextWeight,
    handleSubmit,
    control,
    errors,
    emailData,
    loading,
    onSubmit,
  } = Functions();

  return (
    <div className="bg-primary scroll-container h-screen">
      <div className="sm:py-5 lg:py-10 max-w-7xl lg:px-5 xl:px-10 sm:px-5 xs:px-3 m-auto">
        <div className="flex justify-center items-center xs:py-5">
          <Newlogo />
        </div>
        <Text
          text={"Forget Password"}
          size={fontSizes.h30}
          weight={TextWeight.Unbounded_bold}
          isCenter={true}
          isTruncate={false}
          color="text-secondary"
          className={"sm:py-3"}
        />
      </div>
      <div className="max-w-7xl lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto">
        <form
          className="flex justify-center items-center flex-col"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="relative mt-7 sm:w-[60%] xs:w-full lg:w-[50%]">
            <FormInput
              label={"Email Address"}
              control={control}
              userData={emailData}
              name="email"
              type="email"
              // maxLength={30}
              errors={errors}
              isMandatory={true}
            />
          </div>
          <Button
            text="Submit"
            type={"submit"}
            bgColor="gradient-container_btn"
            color="text-secondary"
            className="xs:w-56 xs:h-10 sm:w-60 sm:h-12 lg:w-64 lg:h-12 mt-2.5 sm:mt-5 lg:mt-6"
            textSize={fontSizes.h16}
            weight={TextWeight.Onest_semiBold}
            loading={loading}
            isDisabled={loading}
          />
        </form>
      </div>
    </div>
  );
};
export default ForgetPassword;
